.wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* Dashed pill — reads as an "add" affordance, same height as the Select triggers. */
.trigger {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  height: 36px;
  padding: 0 var(--space-3);
  background: transparent;
  border: 1px dashed var(--border-default);
  border-radius: var(--radius-md);
  color: var(--text-muted);
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  font-weight: var(--weight-semi);
  cursor: pointer;
  white-space: nowrap;
  transition:
    border-color var(--duration-fast) var(--ease-default),
    color var(--duration-fast) var(--ease-default);
}

.trigger:hover,
.triggerOpen {
  border-color: var(--accent-secondary);
  color: var(--text-primary);
}

/* ── Menu ── */
.menu {
  position: absolute;
  left: 0;
  top: 100%;
  margin-top: var(--space-2);
  min-width: 180px;
  max-height: 320px;
  overflow-y: auto;
  background: var(--bg-elevated);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  padding: var(--space-1);
  z-index: var(--z-dropdown);
  box-shadow: var(--shadow-lg);
}

.option {
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--space-2) var(--space-3);
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-secondary);
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  text-align: left;
  cursor: pointer;
  transition:
    background var(--duration-fast) var(--ease-default),
    color var(--duration-fast) var(--ease-default);
}

.option:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
}
